import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { CompanyDocumentService } from '../../services/company-documents.service';
import { DocumentTypeService } from '../../../services/document-type.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentService } from '../../../documents/services/document.service';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';

@Component({
  selector: 'app-company-documents-page',
  templateUrl: './company-documents-page.component.html',
  styleUrls: ['./company-documents-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyDocumentsPageComponent implements OnInit, OnDestroy {
  companyDocumentSummaries: IDocumentSummaryInfo[] = [];
  companyDocumentTypes: IDocumentType[];
  loading: boolean;
  documentsLoading: boolean = false;
  companyDocumentsLoading: boolean = true;
  isOnMobile: boolean = true;

  loggedInUser: IUserInfo;
  private companyId: string = consts.emptyGuid;
  private loggedInUserSubscription: Subscription;

  constructor(private documentTypeService: DocumentTypeService,
    private companyDocumentService: CompanyDocumentService,
    private documentService: DocumentService,
    private documentModalService: DocumentModalService,
    private confirmProcessService: EcaConfirmProcessService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private helpService: HelpModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private alertsService: AlertsService,
    private userService: OurUserService, private errorHandlingService: ErrorHandlingService
  ) { }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        if (user) {
          this.updateUserAndReload(user);
          this.populateBreadcrumbs();
        }
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })

    const navAction = this.activatedRoute.snapshot.params.navAction;
    // TODO Change to route data, rather than params?
    if (navAction === 'add-document') {
      this.addCompanyDocument();
    }
    this.documentTypeService.getAllDocumentTypesForEntityType(DocumentEntityType.company).subscribe(companyDocumentTypes => {
      this.companyDocumentTypes = companyDocumentTypes;
      this.companyDocumentsLoading = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  private updateUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    this.getCompanyDocumentSummaries(this.companyId);
  }

  downloadCompanyDocument(companyDocument: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(companyDocument, true);
  }

  openCompanyDocument(companyDocument: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(companyDocument);
  }

  getCompanyDocumentSummaries(companyId: string, includeExpired: boolean = false) {
    this.companyDocumentSummaries = [];

    this.companyDocumentService.getAllDocumentSummariesForEnterprise(companyId, includeExpired).subscribe(companyDocuments => {
      companyDocuments?.forEach(companyDocument => this.companyDocumentSummaries.push(companyDocument));
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    ////Company Documents
    //this.companyDocumentService.getAllDocumentSummariesByEntityType(companyId, DocumentEntityType.company, includeExpired).subscribe(companyDocuments => {
    //  companyDocuments?.forEach(companyDocument => this.companyDocumentSummaries.push(companyDocument));
    //}, () => {
    //  this.errorHandlingService.showErrorWarning().subscribe(() => {
    //  });
    //});

    ////Training Course Documents
    //this.companyDocumentService.getAllDocumentSummariesByEntityType(companyId, DocumentEntityType.trainingCourse, includeExpired).subscribe(trainingCourseDocuments => {
    //  trainingCourseDocuments?.forEach(trainingCourseDocument => this.companyDocumentSummaries.push(trainingCourseDocument));
    //}, () => {
    //  this.errorHandlingService.showErrorWarning().subscribe(() => {
    //  });
    //});

    ////Observation Documents (Company specific)
    //this.companyDocumentService.getAllDocumentSummariesByEntityType(companyId, DocumentEntityType.observation, includeExpired).subscribe(observationDocuments => {
    //  observationDocuments?.forEach(observationDocument => this.companyDocumentSummaries.push(observationDocument));
    //}, () => {
    //  this.errorHandlingService.showErrorWarning().subscribe(() => {
    //  });
    //});
  }

  deleteCompanyDocumentClick(companyDocument: IEntityDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete this document?',
      'Delete ' + companyDocument.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.companyDocumentsLoading = true;
            this.deleteCompanyDocument(companyDocument);
          }
        }
      });
  }

  deleteCompanyDocument(companyDocument: IEntityDocumentSummary) {
    this.companyDocumentService.deleteCompanyDocument(companyDocument.documentId, this.companyId).subscribe(
      result => {
        if (result) {
          this.getCompanyDocumentSummaries(this.companyId);
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
        }
        this.companyDocumentsLoading = false;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
  }

  addCompanyDocument() {
    this.documentModalService.openDocumentUploaderModal(null, DocumentEntityType.company, 'Add Enterprise Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          this.companyDocumentsLoading = true;
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('CompanyId', this.companyId);
          this.loading = true;
          this.companyDocumentService.createOrUpdateCompanyDocument(documentUploadRequest).subscribe(companyDocumentSummary => {
            this.loading = false;
            this.getCompanyDocumentSummaries(this.companyId);
            this.companyDocumentsLoading = false;
            this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        });
      });
  }

  editCompanyDocument(companyDocumentSummary: IEntityDocumentSummary) {
    this.documentModalService.openDocumentUploaderModal(companyDocumentSummary, DocumentEntityType.company, 'Edit Enterprise Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          this.companyDocumentsLoading = true;
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('CompanyId', this.companyId);
          this.loading = true;
          this.companyDocumentService.createOrUpdateCompanyDocument(documentUploadRequest).subscribe(updatedCompanyDocumentSummary => {
            this.loading = false;
            this.getCompanyDocumentSummaries(this.companyId);
            this.companyDocumentsLoading = false;
            this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        });
      });
  }

  viewCompanyDocument(companyDocument: IEntityDocumentSummary) {
    if (companyDocument.entityType === DocumentEntityType.company) {
      this.router.navigate(['company-document', companyDocument.documentId]);
    }
    else if (companyDocument.entityType === DocumentEntityType.trainingCourse) {
      this.router.navigate(['/training-course-document/', companyDocument.documentId]);
    }
    else if (companyDocument.entityType === DocumentEntityType.observation) {
      this.router.navigate(['/observation-document/', companyDocument.documentId]);
    }
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({
      label: this.loggedInUser?.companyName?.toString() + ' - ' + 'Enterprise Documents',
      iconName: 'books',
    } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  refreshDocuments(includeExpired: boolean) {
    this.getCompanyDocumentSummaries(this.companyId, includeExpired);
  }

  ngOnDestroy(): void {
    this.loggedInUserSubscription.unsubscribe();
  }

  openCompanyDocumentsHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanyDocumentsHelp);
  }
}
